function generateState() {
    return () => {
        return {
            order: {},
            restaurant: {},
            trackOrder: {},
            deliveryJob: {},
            deliveryStatus: null,
            orderError: false,
            waitingForUpdate: false,
            // tasks#202: the reactive clock (ms) the estimated window's never-past shift is computed against
            now: Date.now(),
        }
    }
}

export default generateState
